import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_PETITION_KICKSTART_TOGGLE = createFcmDetails('starfish_petition_kickstart_toggle', {
	owner: 'starfish',
	context: 'Petition Free Promotion Kickstart',
	description:
		'Feature toggle for the petition kickstart UI in the starter onboarding flow that is tied to an experiment `petitionKickstartToggle`',
	mergeLogic: 'Needs combination of both country code and locale to be enabled',
	import: false,
});
